import type {ContainerQueryObject} from '@Hooks/useContainerQuery';
import type {DesignSelection} from '@Components/social-media/social-media.types';

export interface SocialMediaWizardFooterProps {
  isSmallScreen: boolean;
  hasReachedReviewStep: boolean;
  onNext: VoidFunction;
  onBack: VoidFunction;
  currentSelectedDesigns: DesignSelection[];
}

export const SOCIAL_MEDIA_WIZARD_FOOTER_CONTAINER_QUERY: ContainerQueryObject = {
  xlarge: {
    minWidth: 1200,
  },
};

export const PUBLISH_ANIMATABLE_ICON_CLASS = 'icon-publish-arrow';
